// import React, { memo } from 'react';
// import { useTranslation } from 'react-i18next';
// import BasicModal from './BasicModal';
// import { CustomTextInput } from './CustomTextInput';
// import { CustomSwitchInput } from './CustomSwitchInput';
// import CustomMobileInput from './CustomMobileInput';

// const UserDetailsDialog = ({
//   open,
//   onClose,
//   userDetails = {},
//   handleChange,
//   handleSubmit,
//   disabled = false,
//   error = {},
// }) => {
//   const { t } = useTranslation();

//   const {
//     first_name = '',
//     last_name = '',
//     username = '',
//     email = '',
//     mobile_number = '',
//   } = userDetails;

//   /**
//        * Handles setting the mobile value and selected country length.
//        * @param {string} value - The value of the input field.
//        * @param {object} country - The selected country object.
//        * @param {object} e - The event object.
//        */
//       const handleSetMobile = (value, country, e) => {
//           const phoneNumber = e.target.value;
//           let phonePrfix = country.format[0]+country.dialCode;
//           const format = country.format;
//           const sliced = format.slice(format.indexOf(" ") + 1);
//           const dotCount = getDotCount(sliced);
//           storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_PHONE_PREFIX, phonePrfix);
//           storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_PHONE_NUMBER_LENGTH, dotCount);
//           if (phoneNumber) {
//               setSelCountryLength(country.format.length);
//               setMobile(phoneNumber);
  
//               // Validate phone number (example validation: length check)
//               const isValidPhoneNumber = phoneNumber.length > 8 ? true : false;
  
//               if (!isValidPhoneNumber) {
//                   setErrorMessage(t('LoginPhoneError'));
//               } else {
//                   setErrorMessage('');
//               }
//               setDisabled(!isValidPhoneNumber);
//           }
//       };
  
  
//       /**
//        * Handles the change event of the email input field.
//        * 
//        * @param {Event} e - The event object.
//        * @returns {void}
//        */
//       const handleSetEmail = (e) => {
//           const email = e.target.value;
//           setEmail(email);
  
//           if (!REGEXP_EMAIL.test(email)) {
//               setErrorMessage(t('LoginEmailError'));
//           } else {
//               setErrorMessage('');
//           }
//           setDisabled(!REGEXP_EMAIL.test(email));
//       };
//   return (
//     <BasicModal
//       open={open}
//       onClose={onClose}
//       onCancel={onClose}
//       onSubmit={handleSubmit}
//       title={t('User Details')}
//       cancelText={t('Cancel')}
//       submitText={t('Submit')}
//     >
//       <div className="user-details-form">
//         <CustomTextInput
//           autoFocus
//           placeholder={t('First_Name')}
//           value={first_name}
//           onChange={(e) => handleChange('first_name', e.target.value)}
//           disabled={disabled}
//         />
//         {error.first_name && <span className="error">{error.first_name}</span>}

//         <CustomTextInput
//           placeholder={t('Last_Name')}
//           value={last_name}
//           onChange={(e) => handleChange('last_name', e.target.value)}
//           disabled={disabled}
//         />
//         {error.last_name && <span className="error">{error.last_name}</span>}

//         <CustomTextInput
//           placeholder={t('Username')}
//           value={username}
//           disabled
//           onChange={(e) => handleChange('username', e.target.value)}
//         />
//         {error.username && <span className="error">{error.username}</span>}

//         <CustomTextInput
//           placeholder={t('Email')}
//           value={email}
//           disabled
//           onChange={(e) => handleChange('email', e.target.value)}
//         />
//         {error.email && <span className="error">{error.email}</span>}
//         <CustomTextInput
//           placeholder={t('Mobile')}
//           value={mobile_number}
//           onChange={(e) => handleChange('mobile_number', e.target.value)}
//           disabled={disabled}
          
//         />
//         <CustomMobileInput
//                     handleSetMobile={()=>{}}
//                     value={mobile_number}
//                     handleKeyDown={()=>{}}
//                     hasError={error}
//                     disabled={disabled}
//           />

//         {error.mobile_number && <span className="error">{error.mobile_number}</span>}
//       </div>
//     </BasicModal>
//   );
// };

// export default memo(UserDetailsDialog);


import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import BasicModal from './BasicModal';
import { CustomTextInput } from './CustomTextInput';
import CustomMobileInput from './CustomMobileInput';

const UserDetailsDialog = ({
  open,
  onClose,
  userDetails = {},
  handleChange,
  handleSubmit,
  disabled = false,
  error = {},
}) => {
  const { t } = useTranslation();

  const {
    first_name = '',
    last_name = '',
    username = '',
    email = '',
    mobile_number = '',
  } = userDetails;

  return (
    <BasicModal
      open={open}
      onClose={onClose}
      onCancel={onClose}
      onSubmit={handleSubmit}
      title={t('UserTitle')}
      cancelText={t('Cancel')}
      submitText={t('Submit')}
    >
      <div className="user-details-form">
        {/* First Name */}
        <CustomTextInput
          autoFocus
          placeholder={t('First_Name')}
          value={first_name}
          onChange={(e) => handleChange('first_name', e.target.value)}
          disabled={disabled}
        />
        {error.first_name && <span className="error">{error.first_name}</span>}

        {/* Last Name */}
        <CustomTextInput
          placeholder={t('Last_Name')}
          value={last_name}
          onChange={(e) => handleChange('last_name', e.target.value)}
          disabled={disabled}
        />
        {error.last_name && <span className="error">{error.last_name}</span>}

        {/* Email (read-only or editable — your choice) */}
        <CustomTextInput
          placeholder={t('Email')}
          value={email}
          disabled={disabled}
          onChange={(e) => handleChange('email', e.target.value)}
        />
        {error.email && <span className="error">{error.email}</span>}

        {/* Mobile */}
        <CustomMobileInput
          value={mobile_number}
          handleSetMobile={(value) => handleChange('mobile_number', value)}
          disabled={disabled}
          hasError={!!error.mobile_number}
        />
        {error.mobile_number && (
          <span className="error">{error.mobile_number}</span>
        )}
      </div>
    </BasicModal>
  );
};

export default memo(UserDetailsDialog);
